import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
//import ProductList from "./components/ProductList";
import MovieList from "./components/MovieList";
//import AddProduct from "./components/AddProduct";

//import EditProduct from "./components/EditProduct";

import EditMovie from "./components/EditMovie";
import AddMovie from "./components/AddMovie";
 
function App() {
  return (
    <Router>
      <div className="container">
        <div className="columns">
          <div className="column is-half is-offset-one-quarter">
            
            <Routes>
              <Route exact path="/" element={<MovieList  />} />            
              <Route path="/add" element={<AddMovie />} />
              <Route path="/edit/:id" element={<EditMovie />} />
            </Routes>
            
          </div>
        </div>
      </div>
    </Router>
    
  );
}
 
export default App;